import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./map.html';
import styles from './PaQuickQuoteLocationMap-hashed.scss';
import controller from './PaQuickQuoteLocationMapCtrl';

export default {
    template: cssUtil.hashTemplate(template, styles),
    controller,
    bindings: {
        mapName: '@',
        coords: '<',
        getDeviceLocation: '&',
        address: '<',
        defaultLocation: '<'
    }
};